(function () {
  "use strict";

  const MINUS_SVG =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H3.75C3.55109 12.75 3.36032 12.671 3.21967 12.5303C3.07902 12.3897 3 12.1989 3 12C3 11.8011 3.07902 11.6103 3.21967 11.4697C3.36032 11.329 3.55109 11.25 3.75 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12Z" fill="#151618"/></svg>';

  const PLUS_SVG =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H12.75V20.25C12.75 20.4489 12.671 20.6397 12.5303 20.7803C12.3897 20.921 12.1989 21 12 21C11.8011 21 11.6103 20.921 11.4697 20.7803C11.329 20.6397 11.25 20.4489 11.25 20.25V12.75H3.75C3.55109 12.75 3.36032 12.671 3.21967 12.5303C3.07902 12.3897 3 12.1989 3 12C3 11.8011 3.07902 11.6103 3.21967 11.4697C3.36032 11.329 3.55109 11.25 3.75 11.25H11.25V3.75C11.25 3.55109 11.329 3.36032 11.4697 3.21967C11.6103 3.07902 11.8011 3 12 3C12.1989 3 12.3897 3.07902 12.5303 3.21967C12.671 3.36032 12.75 3.55109 12.75 3.75V11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12Z" fill="#151618"/></svg>';

  function isVisible(el) {
    return el && window.getComputedStyle(el).display !== "none";
  }

  function initFaq(root) {
    const scope = root || document;
    const bodies = scope.querySelectorAll(".accordion_body");
    const heads = scope.querySelectorAll(".accordion_head");
    if (!bodies.length) return;

    bodies.forEach((body, i) => {
      body.style.display = i === 0 ? "block" : "none";
    });

    const firstPlus = scope.querySelector(".accordion_head .plusminus");
    if (firstPlus) firstPlus.innerHTML = MINUS_SVG;

    heads.forEach((head) => {
      head.addEventListener("click", () => {
        const body = head.nextElementSibling;
        if (!body || !body.classList.contains("accordion_body")) return;
        const plus = head.querySelector(".plusminus");
        const wasOpen = isVisible(body);

        bodies.forEach((b) => {
          b.style.display = "none";
        });
        scope.querySelectorAll(".accordion_head .plusminus").forEach((p) => {
          p.innerHTML = PLUS_SVG;
        });

        if (!wasOpen) {
          body.style.display = "block";
          if (plus) plus.innerHTML = MINUS_SVG;
        }
      });
    });
  }

  window.theme = window.theme || {};
  theme.blueLightFaq = { init: initFaq };

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".mainFaq").forEach((el) => initFaq(el));
  });
})();
